import React from 'react';
import PropTypes from 'prop-types';
import { formatClassName } from '../../utils';

export const FilterMenu = props => {
  const { children, className, ...extraProps } = props;

  return (
    <div className={formatClassName([className, 'filter-menu'])} {...extraProps}>
      {children}
    </div>
  );
};

FilterMenu.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
